import React from "react";
import {connect} from "react-redux";
import {Dimensions, FlatList, KeyboardAvoidingView, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import ExplorerThemeListItem from "./ExplorerThemeListItem";
import BarreRecherche from "../Header/BarreRecherche";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {wrapAction, wrapStyle} from "../../sw/helpers";
import CheckActivePicto from "../Picto/CheckActivePicto";
import CheckNotActivePicto from "../Picto/CheckNotActivePicto";


class ExplorerThemeList extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            search: "",
	    active_display_list: true
        };
        this.search = this.search.bind(this);
    }

    // return a list of item matching or true if all matches
    mayFilterSearch(data_source, search) {
        search = search.toLowerCase();
        let search_list = [];

        if(search === "") return true;

        const saveOnMatch = (theme) => {
          if (theme.item.toLowerCase().includes(search)) {
            search_list.push(theme)
          }
        }

        // traverse data_source and register who need it
        data_source.forEach(root => {
          saveOnMatch(root);
          root.children.forEach(subroot => {
            saveOnMatch(subroot);
            subroot.children.forEach(saveOnMatch);
          })
        })

        return search_list;
    }

    mayFilterData(data_source, focus_list, search_list) {
      // no filter
      if (focus_list === true && search_list === true) return data_source;

      let build_from;

      if (focus_list === true) {
        build_from = search_list;
      } else if (search_list === true) {
        build_from = focus_list;
      } else {
        // search_list is restricted to those already in focus
        build_from = focus_list.filter(a => search_list.find((b) => a.id == b.id))
      }

      let ids = {};
      build_from.forEach(x => {
        ids[x.root] = true;
        ids[x.subroot] = true;
        ids[x.id] = true;
      });

     return data_source.filter(root =>{ return ids[root.id]}).map(root => {

        const subroots = root.children
          .filter(subroot => ids[subroot.id])
          .map(subroot => {
            const leaves = subroot.children.filter(leaf => ids[leaf.id])

            return {...subroot, children: leaves};
          })
        return {...root, children: subroots}
      });


    }

    getDisplayTheme(idThemesToDisplay){

    }

    renderEmptyContainer(width, height){
        return (<View style={{width:width,height:height,justifyContent:"center",alignItems:"center"}}><Text style={{color : this.props.theme.colors.tertiary.black1.value,fontFamily:this.props.theme.fonts.text}}>Aucun élément à afficher</Text></View>)
    }

    search(text){
        this.setState({
            search : text
        });
    }

    renderSelector(styles) {
      const {active_display_list} = this.state;

      const cb = () => {
	if (active_display_list !== true) {
	  this.setState({active_display_list: true})
	} else {
	  const {focusList, focusListSet, notificationList, notificationListSet} = this.props;

	  this.setState({
	    active_display_list: focusList.concat(focusListSet, notificationList, notificationListSet)
	  })
	}
      };

      // true when accepts all (it is not set, should be an array otherwise)
      return <TouchableOpacity style={styles.containerSelectAll} onPress={wrapAction(cb)}>
	<View>
	  {
	  active_display_list === true
	  ? <CheckNotActivePicto isHeader={true} style={{width:26,height:26}} />
	  : <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
	  }
	</View>
	<Text style={styles.selectAllText}>
	  {this.props.t('Show active elements only')}
	</Text>
      </TouchableOpacity>
    }

    render(){
        // avoid at render...
        const { width, height } = Dimensions.get('window');

        const styles = StyleSheet.create({
           container:{
               width: width,
               flex:1
           },
            selectAllText : {
                color : this.props.theme.colors.primary.blue1.value,
                fontFamily: this.props.theme.fonts.text,
		marginLeft: 5
            },
            containerSelectAll : wrapStyle({
                borderTopWidth:1,
                borderBottomWidth:1,
                borderColor:this.props.theme.colors.tertiary.black13.value,
                flexDirection:"row",
                alignItems:"center",
                marginVertical:10,
		paddingVertical:10,
                marginHorizontal:20
            })
        });
        const cp = this.props.data.slice();

        let maybe_search_list = this.mayFilterSearch(cp, this.state.search);
        let maybe_focus_list;

	if (this.props.isUpdate && this.state.active_display_list !== true) {
	  maybe_focus_list = this.state.active_display_list;
	} else if (this.props.isUpdate || (!this.props.isFocus && !this.props.isEntityScreen)) {
	  maybe_focus_list = true;
	} else {
	  // what about order??
	  const dedup_notification_list = this.props.notificationList.filter(x => !this.props.focusList.some(y => x.id == y.id))

	  // maintain sort by asc id
	  maybe_focus_list = this.props.focusList.concat(dedup_notification_list).sort((a, b) => a.id - b.id);
	}

        let data = this.mayFilterData(cp, maybe_focus_list, maybe_search_list);

        const header = (this.props.isUpdate)? (
            <View style={{width:width,alignItems:"center"}}>
                <View style={{width:"90%",height:60,marginHorizontal:10}}>
                    <BarreRecherche search={this.search}  fullScreen={true} />
                </View>
                { this.renderSelector(styles) }
            </View>) : (!this.props.isFocus || (this.props.isFocus && this.props.focusList.length>0)) ?(  <View style={{width:width,alignItems:"center"}}>
            <View style={{width:"90%",height:60,marginHorizontal:10}}>
                <BarreRecherche search={this.search} fullScreen={true} />
            </View>
        </View> ):(<View></View>)

        const renderItem = (item) => {
          return <ExplorerThemeListItem
              navigateToEntityScreen={this.props.navigateToEntityScreen}
              isUpdate={this.props.isUpdate}

              focusList={this.props.focusList}
              focusListSet={this.props.focusListSet}
              focusListUnSet={this.props.focusListUnSet}
              setFocusList = {this.props.setFocusList}

              notificationList={this.props.notificationList}
              notificationListSet={this.props.notificationListSet}
              notificationListUnSet={this.props.notificationListUnSet}
              setNotificationList = {this.props.setNotificationList}

              isFocus={this.props.isFocus}
              isFocused={(this.props.focusList || []).some(focus => focus.id == item.id)}
              isNotification={(this.props.notificationList || []).some(notif => notif.id == item.id)}

              item={item.item} />
        }

        return (
          <View style={styles.container}>
            <View style={{width:width, marginBottom:40, alignItems:"center"}}>
             <FlatList
                    style={{width:"100%", marginTop:10, marginHorizontal:10, height: (this.props.isFocus) ? height-202 : height-202 }}
                    data={data}
                    keyExtractor={(item) => item.id}
                    ListHeaderComponent={header}
                    renderItem={renderItem}
                    ListEmptyComponent={this.renderEmptyContainer(width, height)}
             />
            </View>
          </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}

export default compose(withTranslation(),connect(mapStateToProps))(ExplorerThemeList);
